import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'

import { isUndefined, isEmpty, isNull } from 'lodash'

import { Box, Container, Typography } from '@material-ui/core'

import ProfileLayout from '@scoir/components-core/dist/components/ProfileLayout'
import Avatar from '@scoir/components-core/dist/components/Avatar'
import { imageAsFullImageSrc } from '@scoir/avatar-image-url'
import { ConfirmationDialog } from '@scoir/modals'

import api from 'common/api'
import { actions as userActions } from 'store/user'
import { actions as snactions } from 'store/snackbar'
import ShowAvatar from 'components/ShowAvatar'
import FourOhFourRoute from 'routes/status/FourOhFour'

import ProfileInfoRoute from './ProfileInfo'
import AccountSettings from './AccountSettings'

export class MyProfile extends React.Component {
  state = {
    showDelete: false,
  }
  updateUser(newUser) {
    return this.props.updateUser(newUser)
  }
  updateAvatar(fileKey) {
    return this.props.updateAvatar(fileKey)
  }
  deleteAvatar() {
    api
      .delete('/api/user/avatar')
      .then(() => {
        this.setState({ showDelete: false })
        return this.props.fetchUser()
      })
      .catch(() => this.props.addSnack('An error occured while deleting avatar.'))
  }

  renderRoute(children) {
    const name = `${this.props.user.FirstName} ${this.props.user.MiddleName} ${this.props.user.LastName}`
    const avatarSrc = this.props.user.AvatarUrl ? imageAsFullImageSrc(this.props.user.AvatarUrl) : undefined
    const hasAvatar =
      !isUndefined(this.props.user.AvatarUrl) &&
      !isEmpty(this.props.user.AvatarUrl) &&
      !isNull(this.props.user.AvatarUrlrUrl)

    return (
      <Container maxWidth={false}>
        <ProfileLayout
          theme="light"
          name={name}
          links={[
            {
              path: `${this.props.match.path}/info`,
              label: 'My Info',
            },
            {
              path: `${this.props.match.path}/account-settings`,
              label: 'Account Settings',
            },
          ]}
          avatar={() => {
            return (
              <ShowAvatar
                editable={true}
                avatarUrl={this.props.user.AvatarUrl}
                circle={true}
                borderless={true}
                onDelete={hasAvatar ? () => this.setState({ showDelete: true }) : undefined}
                onPickAvatar={(fileInfo) => this.updateAvatar(fileInfo.key)}
              />
            )
          }}
        >
          {children}
        </ProfileLayout>

        <ConfirmationDialog
          open={this.state.showDelete}
          headerText="Confirm Delete"
          onConfirm={() => this.deleteAvatar()}
          onClose={() => this.setState({ showDelete: false })}
        >
          <>
            <Typography>Are you sure you want to remove this image from your profile?</Typography>
            <Box
              mt={2}
              width="100px"
            >
              <Avatar
                circle
                src={avatarSrc}
                editable={false}
              />
            </Box>
          </>
        </ConfirmationDialog>
      </Container>
    )
  }
  render() {
    return (
      <Switch>
        <Route
          exact
          path={`${this.props.match.path}/info`}
          render={(props) =>
            this.renderRoute(
              <ProfileInfoRoute
                user={this.props.user}
                onSave={(newUser) => this.updateUser(newUser)}
                {...props}
              />,
            )
          }
        />
        <Route
          exact
          path={`${this.props.match.path}/account-settings`}
          render={(props) => this.renderRoute(<AccountSettings {...props} />)}
        />
        <FourOhFourRoute />
      </Switch>
    )
  }
}

MyProfile.propTypes = {
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  addSnack: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  updateAvatar: PropTypes.func.isRequired,
}

export default connect(
  (store) => ({
    user: store.user.record,
  }),
  {
    updateUser: userActions.updateUser,
    updateAvatar: userActions.updateAvatar,
    fetchUser: userActions.fetchUser,
    addSnack: snactions.addSnackbarItem,
  },
)(MyProfile)
